import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'clipboard-list';

const originalDimensions = {
    width: 24,
    height: 24,
};

// stockholm-icon-set/Communication/Clipboard-list.svg

export const IconClipboardList = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, handleClick } = props;
    const classNames = cx(addClasses, 'inline', {
        'cursor-pointer': handleClick,
    });

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            onClick={(e: SyntheticEvent): void => {
                if (handleClick) {
                    handleClick(e);
                }
            }}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Clipboard List Icon</title>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M8 3v.5A1.5 1.5 0 009.5 5h5A1.5 1.5 0 0016 3.5V3h2a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2V5a2 2 0 012-2h2z"
                    fill={fill}
                    opacity=".3"
                />
                <path
                    d="M11 2a1 1 0 012 0h1.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H11z"
                    fill={fill}
                />
                <rect
                    fill={fill}
                    opacity=".3"
                    x="10"
                    y="9"
                    width="7"
                    height="2"
                    rx="1"
                />
                <rect
                    fill={fill}
                    opacity=".3"
                    x="7"
                    y="9"
                    width="2"
                    height="2"
                    rx="1"
                />
                <rect
                    fill={fill}
                    opacity=".3"
                    x="7"
                    y="13"
                    width="2"
                    height="2"
                    rx="1"
                />
                <rect
                    fill={fill}
                    opacity=".3"
                    x="10"
                    y="13"
                    width="7"
                    height="2"
                    rx="1"
                />
                <rect
                    fill={fill}
                    opacity=".3"
                    x="7"
                    y="17"
                    width="2"
                    height="2"
                    rx="1"
                />
                <rect
                    fill={fill}
                    opacity=".3"
                    x="10"
                    y="17"
                    width="7"
                    height="2"
                    rx="1"
                />
            </g>
        </svg>
    );
};
